module.exports = __webpack_public_path__ + "static/dust_of_disappearance-e6afdef0c2bccd05e7b3bca3414b9e18.jpeg";